export class ImageUploadPayload {
  public imageUrl: string;
  public uploadUri: string;

  constructor (imageUrl: string, uploadUri: string) {
    this.imageUrl = imageUrl;
    this.uploadUri = uploadUri;
  }
}
